import React from "react";
import { EnrichedSwarovskiProductFrontendProductReview, SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { ReviewTranslations } from "./reviewTranslations";
import { css } from "@emotion/react";
import { PDPReviewCommentTopBarShell } from "./PDPReviewCommentTopBarShell";
import { PDPReviewComment } from "./PDPReviewComment";
import { FONTS } from "../../styles/fonts";
import { CSS_MQ } from "../../styles/breakpoints";

export const PDPReviewReply: React.FC<{
  reply: EnrichedSwarovskiProductFrontendProductReview["replies"][number];
  t: ReviewTranslations;
  reviewDateFormatter: (createdDateIsoString: string) => string;
}> = ({ reply: { comment, author, createdDateIsoString }, t, reviewDateFormatter }) => {
  return (
    <div
      className="u-relative so-bg-white"
      css={css`
        padding: var(--p);
      `}
    >
      <PDPReviewCommentTopBarShell
        leftSide={
          <div
            css={css`
              display: flex;
              gap: 4px;

              ${CSS_MQ.atMostSm} {
                flex-direction: column;
                gap: 0;
                margin-right: 50px;
              }
            `}
          >
            <span>{author.name}</span>
            <span title={createdDateIsoString} css={FONTS.SwarovskiFutura300}>
              {reviewDateFormatter(createdDateIsoString)}
            </span>
          </div>
        }
        rightSide={
          author.avatar ? (
            <img
              className="u-absolute u-right u-top"
              src={author.avatar}
              css={css`
                height: 70px;
              `}
            />
          ) : null
        }
      />

      <PDPReviewComment comment={comment} t={t} />
    </div>
  );
};
